<template>
  <CommonOverlay class="overlay" v-show="!isClosePopup && rank > 0">
    <CommonModal class="modal pack-confirm" style="margin-top: -40px;">
      <div class="area-rankup">
        <div class="rankup-top">
          <p><img src="/img/rank/ru-omedeto.png" alt="ランクアップおめでとう！"></p>
          <p><img :src="'/img/rank/rankup_' + rank + '.png'" class="rank"></p>
        </div>

        <div class="rankup-bonus">
          <p>ランクアップボーナス！</p>
          <p v-if="rank != 7"><img :src="'/img/rank/pt_' + rank + '.png'" :alt="getRankupBonus() + 'pt'"></p>
          <p v-if="rank == 7"><img :src="'/img/rank/pt_' + rank + '.png'" alt="選べるPSA10(20万PT相当)"><br>
            <span class="micro">※発送時の相場になります</span>
          </p>
        </div>

        <div class="bonus-list">
          <p>現在のランクボーナス</p>
          <ul>
            <li>購入金額ごとに{{(rankupData.discount * 100) - 100}}%ボーナスPTが付与されます</li>
            <li>ランク限定オリパが解放されます</li>
          </ul>
        </div>

        <div class="rankup-btn">
          <p class="rank-btn btn-left" @click="closePopup"><a>OK</a></p>
          <p class="rank-btn btn-right" @click="openRankDetail"><a>ランク詳細へ</a></p>
        </div>
      </div>
    </CommonModal>
  </CommonOverlay>
</template>

<script>
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import t from '@/plugins/i18n';
import {
  separateCharacterNumber,
} from '@/common/util/format';

export default {
  name: 'OnceMore',
  mixins: [t],
  components: {
    CommonOverlay,
    CommonModal,
  },

  props: {
    rank: {
      type: Number,
      default: 0,
    },
    rankupData: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    isClosePopup: false,
  }),

  methods: {
    getRankupBonus() {
      return separateCharacterNumber(this.rankupData.rankup_bonus);
    },
    closePopup() {
      this.isClosePopup = true;
    },
    openRankDetail() {
      window.open('https://clever-sense-0fe.notion.site/1a1f8228267c80f697caf6d1272e91c4', '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
.overlay {
  z-index: 100;
  .pack-confirm {
    border: none;
    background-color: rgba(0, 0, 0, 0);
    .area-rankup{
      width: 90%;
      height: fit-content;
      max-width: 320px;
      max-height: 100%;
      background-image: url(/img/rank/ru-bg.png);
      background-size: cover;
      background-position: top center;
      margin-left: auto;
      margin-right: auto;
      .rankup-top{
        width: 100%;
        background-image: url(/img/rank/ru-kamifubuki.png);
        background-size: contain;
        background-position: top center;
        padding-top: 10px;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        p {
          margin-bottom: 16px;
        }
        img{
          width: 100%;
          margin-left: auto;
          margin-right: auto;
        }
        img.rank{
          width: 70%;
        }
      }
      .rankup-bonus{
        width: 100%;
        background-image: url(/img/rank/ru-bonus.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
        padding: 10px 0;
        margin-top: 24px;
        p {
          padding: 3px 0 0 0;
          margin: 0;
        }
        img{
          width: 60%;
        }
      }

      .bonus-list{
        margin-top: 10px;
        text-align: center;
        color: #302e38;
        p {
          font-size: 16px;
          font-weight: bold;
        }
        ul {
          padding-left: 0!important;
          li {
            width: 100%;
            font-size: 13px;
            font-weight: bold;
            background: rgb(255,255,255);
            background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 10%, rgba(255,255,255,1) 90%, rgba(255,255,255,0) 100%);
            padding: 5px 0;
            margin: 8px 0;
            list-style: none;
          }
        }
      }

      .rankup-btn{
        width: 100%;
        margin-top: 35px;
        display: flex;
        column-gap: 10px;
        flex-wrap: nowrap;
        justify-content: center;
        a {
          color: #fff!important;
          text-decoration: none!important;
          display: block;
          padding: 8px 8px;
        }
        .rank-btn {
          width: 45%;
          text-align: center;
          color: #fff;
          font-size: 18px;
          font-weight: bold;
          border-radius: 30px;
        }
        .btn-left {
          background: rgb(51,64,102);
          background: linear-gradient(180deg, rgba(74,86,131,1) 0%, rgba(41,47,66,1) 100%);
          border-bottom: 4px solid #151619;
        }
        .btn-right {
          background: rgb(255,50,84);
          background: linear-gradient(180deg, rgba(255,50,84,1) 0%, rgba(208,27,57,1) 100%);
          border-bottom: 4px solid #57101c;
        }
      }
    }
  }
}
.rankup-bonus .micro{
  display: block;
  text-align: right;
  font-size: 11px;
  font-weight: normal;
  margin-right: 5px;
}
</style>
